export enum Themes {
	WHITE = 'theme-white',
	GRAY = 'theme-colored-gray',
	RED = 'theme-colored-red',
	PURPLE = 'theme-colored-purple',
	AQUAMARINE = 'theme-colored-aquamarine',
	GREEN = 'theme-colored-green',
	YELLOW = 'theme-colored-yellow'
}
